







































































































































































import FormCrearDespacho from './FormCrear.vue';
import EditarDespacho from './EditarDespacho.vue';

import DatePicker from '@/reusable/Form/DatePicker.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Watch } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { eventBus, actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '../../components/Confirmation.vue';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { utils, writeFileXLSX } from 'xlsx';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchDespacho } from './fetchDespacho';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FormCrearDespacho,
    EditarDespacho,
    DatePicker,
    'app-confirmacion': Confirmation,
    FormFieldsContainer,
  },
})
export default class Despacho extends ComponenteBase {
  ordesList: any[] = [];
  filtro: string = '';
  consulta: any = {
    orden: '',
    tecnico: '',
    coordinador: '',
    localidad: '',
    courier: '',
    dateStart: moment()
      .subtract(1, 'month')
      .format('YYYY/MM/DD'),
    dateEnd: moment().format('YYYY/MM/DD'),
  };
  funcionalidad: Funcionalidades = Funcionalidades.Despacho;

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        Código: e.despanumero,
        'Fecha Envío': moment(e.despafecha_envia).format('YYYY-MM-DD'),
        Usuario: e.nombre,
        Courier: e.configvalor,
        'Orden Seguimiento': e.despaseguimiento,
        Localidad: e.locaname,
        Coordinador: e.coorname,
        Técnico: e.tecniconame,
        'Actividad de Despacho': e.nombre_add,
        Estado: e.case,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Despachos');
    writeFileXLSX(wb, 'Despachos.xlsx');
    this.$snotify.success('Excel exportado con éxito', 3000);
  }

  async getDespacho() {
    let self = this;
    this.loadingService.showLoading();
    return fetchDespacho(
      {
        orden: this.consulta.orden ? this.consulta.orden : '',
        tecnico: this.consulta.tecnico ? this.consulta.tecnico : '',
        coordinador: this.consulta.coordinador ? this.consulta.coordinador : '',
        localidad: this.consulta.localidad ? this.consulta.localidad : '',
        courier: this.consulta.courier ? this.consulta.courier : '',
        dateStart: this.consulta.dateStart ? this.consulta.dateStart : '',
        dateEnd: this.consulta.dateEnd ? this.consulta.dateEnd : '',
      },
      'conectaDespacho/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  usuarioActivo: any = {};

  async getUsuario() {
    let self = this;
    let user = JSON.parse(localStorage.getItem('user')).id;

    return fetchDespacho({ userId: user }, 'conectaDespacho/getUsuario')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.usuarioActivo = data.data.data;
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
  }

  ordenList: any[] = [];
  tecnico: any[] = [];
  coordinador: any[] = [];
  localidad: any[] = [];
  courrier: any[] = [];

  async getFiltros() {
    let self = this;
    return fetchDespacho({ '': '' }, 'conectaDespacho/getFilter')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordenList = data.data.ORDEN;
          this.tecnico = data.data.TECNICO;
          this.coordinador = data.data.COORDINADOR;
          this.localidad = data.data.LOCALIDAD;
          this.courrier = data.data.CURRIER;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
  }

  despaAnterior: number;

  async getCodigo() {
    let self = this;
    return fetchDespacho({ '': '' }, 'conectaDespacho/getCodigo')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.despaAnterior = parseInt(data.data.data.ult_despanumero);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
  }

  valorMax: number;
  codigosList: any[] = [];

  async datoEditado(dato: boolean) {
    if (dato) {
      this.ordesList = await this.getDespacho();
      this.gridApi.setRowData(this.ordesList);
    }
  }

  async datoNuevo(dato: any) {
    this.ordesList = await this.getDespacho();
    this.gridApi.setRowData(this.ordesList);
    await this.getCodigo();
    this.valorMax = this.despaAnterior + 1;
    this.getFiltros();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.getUsuario();
    this.ordesList = await this.getDespacho();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.getFiltros();
    await this.getCodigo();
    this.valorMax = this.despaAnterior;
  }

  async filtrar() {
    this.ordesList = [];
    this.gridApi.setRowData(this.ordesList);
    this.consulta = {
      orden: this.formFields.orden.value,
      tecnico: this.formFields.tecnico.value,
      coordinador: this.formFields.coordinador.value,
      localidad: this.formFields.localidad.value,
      courier: this.formFields.courier.value,
      dateStart: moment(this.formFields.dateStart.value.toString()).format(
        'YYYY/MM/DD'
      ),
      dateEnd: moment(this.formFields.dateEnd.value.toString()).format(
        'YYYY/MM/DD'
      ),
    };
    this.ordesList = await this.getDespacho();
    this.gridApi.setRowData(this.ordesList);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  clearFilters() {
    this.formFields.orden.value = '';
    this.formFields.tecnico.value = '';
    this.formFields.coordinador.value = '';
    this.formFields.localidad.value = '';
    this.formFields.courier.value = '';
    this.formFields.dateStart.value = moment().subtract(1, 'month');
    this.formFields.dateEnd.value = moment();
    this.filtrar();
  }

  formFields: FormFieldDefMap = {
    orden: {
      label: 'Orden de Seguimiento',
      id: 'despaseguimiento',
      value: '',
    },
    tecnico: {
      label: 'Técnico',
      id: 'tecnicoid',
      value: '',
    },
    coordinador: {
      label: 'Coordinador',
      id: 'coorid',
      value: '',
    },
    localidad: {
      label: 'Localidad',
      id: 'locaid',
      value: '',
    },
    courier: {
      label: 'Courier',
      id: 'configid',
      value: '',
    },
    dateStart: {
      label: 'Fecha Envío Desde',
      value: moment().subtract(1, 'month'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha Envío Hasta',
      value: moment(),
      id: '',
    },
  };

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionCrear];

  // Globales
  tabModel: string = 'tab-3';
  muestraBarraBotones: boolean = false;
  registrosAsociar: any = [];
  rowsPerPageItems: any = [];
  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  showTabPerfiles: boolean = true;
  showTabRoles: boolean = true;
  loadingService = new LoadingService();
  paramsExportar: any; //Parametros para Exportar
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;
  nombreModulo: string = '';
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  modalEsInformar: boolean = false;
  modalEsDetalles: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Código',
        field: 'despanumero',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 100,
        width: 120,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Envío',
        field: 'despafecha_envia',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        valueFormatter: this.dateFormatter,
      },
      {
        headerName: 'Usuario',
        field: 'nombre',
        resizable: true,
        sortable: true,
        width: 170,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Courier',
        field: 'configvalor',
        sortable: true,
        resizable: true,
        width: 170,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Orden Seguimiento',
        field: 'despaseguimiento',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Localidad',
        field: 'locaname',
        sortable: true,
        resizable: true,
        width: 270,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Coordinador',
        field: 'coorname',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Técnico',
        field: 'tecniconame',
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Actividad de Despacho',
        field: 'nombre_add',
        resizable: true,
        width: 130,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Estado',
        field: 'case',
        resizable: true,
        width: 130,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  created() {
    this.initialize();
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.Despacho) {
        if (
          data.action === Accion.Editar ||
          data.action === Accion.VerDetalle ||
          data.action === Accion.InformarRecepcion
        ) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;
          this.modalEsInformar = data.action == Accion.InformarRecepcion;
          this.modalEsDetalles = data.action == Accion.VerDetalle;
          this.editedIndex = data.id;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            /* if(data.action == Accion.InformarRecepcion){
              console.log(item)
            } */
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.despanumero;
          }
        }
      }
    });
  }
  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
  }
}
